<div class="edi-viewer-page">
  <div class="upload-card" *ngIf="!view && !(messageId && messageType)">
    <div>
      <span class="eyebrow">Universal EDI viewer</span>
      <h3>Open a raw EDI document</h3>
      <p>Upload EDIFACT, X12, XML, JSON, CSV, or fixed/text data. The raw file remains the source of truth.</p>
    </div>

    <div class="alert alert-warning" *ngIf="compatibilityWarning">{{ compatibilityWarning }}</div>

    <label class="file-drop">
      <i class="fa-regular fa-file-code"></i>
      <span>{{ selectedFile?.name || 'Choose a document' }}</span>
      <small>Maximum configured size: 10 MB</small>
      <input type="file" (change)="selectFile($event)" />
    </label>

    <label class="ai-option">
      <input type="checkbox" [(ngModel)]="useAi" />
      <span>
        <strong>Use AI-designed friendly view</strong>
        <small>A deterministic complete-source view is used if AI is unavailable.</small>
      </span>
    </label>

    <div class="alert alert-danger" *ngIf="error">{{ error }}</div>

    <button type="button" class="btn btn-primary" [disabled]="!selectedFile || loading" (click)="render()">
      <i class="fa-solid mr-1" [ngClass]="loading ? 'fa-spinner fa-spin' : 'fa-wand-magic-sparkles'"></i>
      {{ loading ? 'Creating view…' : 'Create document view' }}
    </button>
  </div>

  <div class="viewer-toolbar" *ngIf="view || (messageId && messageType)">
    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="openAnotherDocument()">
      <i class="fa-solid fa-arrow-left mr-1"></i>
      Open another document
    </button>
    <button
      type="button"
      class="btn btn-sm btn-outline-secondary ml-2"
      *ngIf="view && selectedFile && useAi"
      [disabled]="loading"
      title="Ignore the saved template and generate a new view"
      (click)="regenerationDialogOpen = true"
    >
      <i class="fa-solid mr-1" [ngClass]="loading ? 'fa-spinner fa-spin' : 'fa-rotate'"></i>
      {{ loading ? 'Regenerating…' : 'Regenerate view' }}
    </button>
  </div>
  <lib-edi-document-viewer *ngIf="view" [view]="view"></lib-edi-document-viewer>
  <lib-edi-document-viewer
    *ngIf="messageId && messageType"
    [messageId]="messageId"
    [messageType]="messageType"
    [useAi]="true"
  ></lib-edi-document-viewer>
  <lib-edi-view-regeneration-dialog
    *ngIf="regenerationDialogOpen"
    [initialInstruction]="view?.regenerationInstruction"
    (confirmed)="confirmRegeneration($event)"
    (cancelled)="regenerationDialogOpen = false"
  ></lib-edi-view-regeneration-dialog>
</div>
